var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDisconnect = function SvgDisconnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 20",
    fill: "#F5F6FA",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.83 18.444v-3.14a1.04 1.04 0 0 0-2.078 0V17.8H2.083V2.083h6.663v2.495a1.04 1.04 0 0 0 2.078 0v-3.14A1.44 1.44 0 0 0 9.385 0H1.44A1.44 1.44 0 0 0 0 1.439v16.994A1.44 1.44 0 0 0 1.44 19.87H9.39a1.422 1.422 0 0 0 1.439-1.427Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.301 6.47c-.34.46-.25 1.11.209 1.457l1.313.979H6.507a1.04 1.04 0 0 0 0 2.077h6.316l-1.313.979c-.46.34-.555.997-.209 1.456.34.46.997.556 1.457.21.006-.007 3.832-2.86 3.826-2.854a1.04 1.04 0 0 0 0-1.665l-3.832-2.847a1.032 1.032 0 0 0-1.451.208Z"
  })));
};

export default SvgDisconnect;